module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "servicelist"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("服务费")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("交易搜索")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入订单号"
    },
    model: {
      value: (_vm.searchlist.trade_id),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "trade_id", $$v)
      },
      expression: "searchlist.trade_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "500px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "width": "100px",
      "text-align": "right",
      "margin-right": "30px"
    }
  }, [_vm._v("订单时间")]), _vm._v(" "), _c('a-range-picker', {
    attrs: {
      "defaultValue": [_vm.moment(_vm.startdate, _vm.dateFormat), _vm.moment(_vm.enddate, _vm.dateFormat)]
    },
    on: {
      "change": _vm.changetime
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchbtn
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [(!_vm.tradelist.length) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tradelist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("订单总金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("服务费")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.tradelist), function(item) {
    return _c('div', {
      key: item,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_vm._v(_vm._s(item.trade_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [(item.TC_Orders[0].sku_title.length > 12) ? _c('span', [_vm._v(_vm._s(item.TC_Orders[0].sku_title.substring(0, 12) + '…'))]) : _c('span', [_vm._v(_vm._s(item.TC_Orders[0].sku_title.substring(0, 10)))]), _vm._v(" "), (item.TC_Orders.length > 1) ? _c('span', [_vm._v(_vm._s('等' + item.TC_Orders.length + '件商品'))]) : _vm._e()]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s('￥' + item.total_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_vm._v(_vm._s(_vm.moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s('￥' + item.service_fee / 100000))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "ghost": "",
        "size": "small",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.gotodetails(item.id)
        }
      }
    }, [_vm._v("详情")])], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.tradesum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2793ceee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/pricepage/servicelist/index.vue
// module id = 2372
// module chunks = 1